module.exports = __webpack_public_path__ + "media/images/app-view-c1a9e0ef.jpg";